import { Icon } from '@design/components/icon/Icon';
import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { enUS } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

import { getFormattedDates } from '../../utils/utils';
import styles from './DateCell.module.scss';

export interface DateCellProps {
  date: Date;
  displayIcon?: boolean;
  timeZone?: string;
  timeFormat?: string;
}

export const DateCell = ({
  date,
  displayIcon = true,
  timeZone = 'America/New_York',
  timeFormat = 'h:mmaaa zz',
}: DateCellProps) => {
  const { isBeforeNineThirtyAm, isAfterFourPm, formattedDate } =
    getFormattedDates(date, timeZone);

  return (
    <span className={styles.dateContainer} data-date-container>
      {formattedDate}
      {displayIcon && (
        <Tooltip
          isTouchDevice={false}
          trigger={TooltipTrigger.Hover}
          label={
            <span className={styles.timeLabel}>
              {formatInTimeZone(date, timeZone, timeFormat, {
                locale: enUS,
              })}
            </span>
          }
        >
          <span className={styles.iconWrapper}>
            {isBeforeNineThirtyAm && (
              <Icon iconName="SunRise" size={16} className={styles.sunRise} />
            )}
            {isAfterFourPm && (
              <Icon iconName="Moon" size={16} className={styles.moon} />
            )}
            {!isBeforeNineThirtyAm && !isAfterFourPm && (
              <Icon iconName="Sun" size={16} className={styles.sun} />
            )}
          </span>
        </Tooltip>
      )}
    </span>
  );
};
